import { Injectable } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { UserEffects } from '../../state/user/user.effects';
import { ICurrentUser } from '../../state/user/user.interface';

/** Keeps the AI pages out of reach while AI is off for the client (`client_info.is_ai_enabled`). */
@Injectable({
  providedIn: 'root',
})
export class AiEnabledGuard {
  constructor(private router: Router) {}

  canActivate: CanActivateFn = (): boolean | UrlTree => {
    const user: ICurrentUser = UserEffects.getUser();

    if (user && user.aiEnabled) {
      return true;
    } else {
      return this.router.createUrlTree(['/error/forbidden']);
    }
  };
}
